// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2d4g7","detailsBorder":"styles_detailsBorder__1XQgm"};